// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1dfss","resendInfoText":"OnGoingPaymentBox_resendInfoText__1NepK"};